module.exports = __webpack_public_path__ + "img/SANTAS HAT.31d224c.svg";